// extracted by mini-css-extract-plugin
export var active = "_2v-7";
export var backButton = "_2v-6";
export var clone = "_2v-c";
export var collapseBar = "_2v-h";
export var collapseMode = "_2v-j";
export var collapsed = "_2v-l";
export var dragHandle = "_2v-a";
export var dropdownIcon = "_2v-e";
export var expanding = "_2v-k";
export var hidden = "_2v-r";
export var iconContainer = "_2v-o";
export var iconSwapper = "_2v-q";
export var navItem = "_2v-4";
export var navItemIcon = "_2v-d";
export var navProfile = "_2v-5";
export var notificationCountBadge = "_2v-g";
export var notificationDot = "_2v-p";
export var optionsContainer = "_2v-f";
export var primaryNav = "_2v-0";
export var primaryTab = "_2v-m";
export var secondaryNav = "_2v-1";
export var selected = "_2v-n";
export var settingsNav = "_2v-2";
export var settingsNavItems = "_2v-3";
export var show = "_2v-b";
export var sideNav = "_2v-i";
export var teamItem = "_2v-8";
export var userProfileItem = "_2v-9";